import * as React from 'react';
import IconTextButton from "diy/custom-components/icon-text-button/IconTextButton";
import l10n = require('diy/util/l10n');

import ViewQuiltIcon from 'material-ui/svg-icons/action/view-quilt';

export interface LayoutRotateProps {
    activeLayout: string;
    availableLayouts: string[];
    disabled?: boolean;
    dataTestId?: string;
    onChange?: (layoutName: string) => void;
}

interface LayoutRotateState {
}

export class LayoutRotate extends React.Component<LayoutRotateProps, LayoutRotateState> {
    render() {
        return (
            <IconTextButton
                style={{marginRight: 12}}
                text={this.getRotateText()}
                Icon={<ViewQuiltIcon/>}
                onTouchTap={() => this.props.onChange(this.getNextLayoutIndex())}
                isDisabled={this.props.disabled}
                useAlternativeColors={true}
                dataTestId={this.props.dataTestId}
            />
        );
    }

    private getNextLayoutIndex() {
        let index = this.props.availableLayouts.indexOf(
            this.props.activeLayout
        );

        if (index < 0) {
            return null;
        }

        return this.props.availableLayouts[(index + 1) % this.props.availableLayouts.length];
    }

    private getRotateText() {
        return l10n.getString('section.actionBar.buttons.layout.label')
            .split(/(\{[^}]+\})/)
            .map((part, i) => {
                if (part === '{currentLayoutNumber}') {
                    return <span
                        key={i}
                        style={{
                            display: 'inline-block',
                            width: '15px',
                            textAlign: 'center'
                        }}
                        data-test-id="section-current-layout-number"
                    >{
                        this.props.availableLayouts.findIndex(
                            (layoutName) => layoutName === this.props.activeLayout
                        ) + 1
                    }</span>;
                }

                if (part === '{totalNumberOfLayouts}') {
                    return <span
                        key={i}
                        style={{
                            display: 'inline-block',
                            minWidth: '15px'
                        }}
                        data-test-id="section-total-layout-number"
                    >{this.props.availableLayouts.length}</span>;
                }

                return part;
            });
    }
}



/** WEBPACK FOOTER **
 ** ./build/js/~/tslint-loader!./source/cdn/document_root/s/diy/module/section/components/basic/LayoutRotate.tsx
 **/